import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUtensils, faHome, faSearch } from '@fortawesome/free-solid-svg-icons';
import './pages.css';

const NotFoundPage = () => {
  return (
    <Container className="not-found-container d-flex flex-column align-items-center justify-content-center min-vh-100 py-5">
      <Row className="text-center mb-4">
        <Col>
          <div className="not-found-icon mb-3">
            <FontAwesomeIcon icon={faUtensils} size="4x" className="text-danger" />
            <span className="not-found-number">404</span>
          </div>
          <h1 className="display-4 fw-bold mb-3">Oops! Page Not Found</h1>
          <p className="lead text-muted">
            The page you're looking for doesn't exist or has been moved.
            <br />
            Let's get you back to enjoying delicious food!
          </p>
        </Col>
      </Row>

      <Row className="justify-content-center">
        <Col md={8} lg={6} className="d-flex flex-column flex-sm-row gap-3 justify-content-center">
          <Button 
            as={Link} 
            to="/" 
            variant="danger" 
            size="lg" 
            className="not-found-btn"
          >
            <FontAwesomeIcon icon={faHome} className="me-2" />
            Return Home
          </Button>
          
          <Button 
            as={Link} 
            to="/menu" 
            variant="outline-danger" 
            size="lg" 
            className="not-found-btn"
          >
            <FontAwesomeIcon icon={faSearch} className="me-2" />
            Browse Menu
          </Button>
        </Col>
      </Row>

      <div className="mt-5 text-center">
        <img 
          src="https://images.unsplash.com/photo-1606787366850-de6330128bfc"
          alt="Delicious food"
          className="img-fluid not-found-illustration"
          style={{ maxHeight: '200px' }}
        />
      </div>
    </Container>
  );
};

export default NotFoundPage;